// ⚠️‼️ WARN: This component is to use in forms only, otherwise use @ui-kit/button ‼️⚠️

import React from "react";
import styled from "styled-components";
import { form } from "@glossy/theme";
import {
  Size,
  VARIANTS,
  Variant,
  height,
  padding,
  radius,
} from "@ui-kit/form/styles";
import Icon from "@ui-kit/icon";

interface IProps {
  size?: Size;
  variant?: Variant;
  onClick?: () => void;
  children: React.ReactNode;
  disabled?: boolean;
  dropdownLookalike?: boolean; // Display a chevron caret on the right side
  className?: string;
}

const Root = styled.button<{
  $size: Size;
  variant: Variant;
  disabled: boolean;
  dropdownLookalike: boolean;
}>`
  width: 100%;
  vertical-align: middle;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  height: ${height}px;
  border-radius: ${radius}px;
  font-size: 14px;
  padding: 0 ${({ dropdownLookalike }) => (dropdownLookalike ? 10 : padding)}px
    0 ${padding}px;
  cursor: pointer;
  user-select: none;
  background-color: transparent;
  color: ${form};
  opacity: ${(props) => props.disabled && 0.5};
  pointer-events: ${(props) => props.disabled && "none"};
  ${(props) => VARIANTS[props.variant]};
`;

const UiKitFormButton = React.forwardRef(
  (
    {
      size = "m",
      variant = "primary",
      onClick,
      children,
      disabled,
      dropdownLookalike,
      className,
      ...props
    }: IProps,
    ref: React.Ref<HTMLButtonElement>
  ) => (
    <Root
      $size={size}
      onClick={onClick}
      variant={variant}
      ref={ref}
      className={className}
      disabled={!!disabled}
      dropdownLookalike={!!dropdownLookalike}
      {...props}
    >
      {children}
      {dropdownLookalike && <Icon glyph="chevron-small-down" size="ms" />}
    </Root>
  )
);

export default UiKitFormButton;
